/* Mega Office Supplies — search UX tweaks
 *
 * Three small corrections to the Searchspring / MR search app, which lives in
 * assets/search-app.js (180KB) and assets/header-search-dropdown.js (1MB). Both are over the
 * themeFilesUpsert limit and cannot be edited, so these are applied after render.
 *
 * 1. Card call-to-action moved below the price
 *    The grid card renders its buttons inside .cgivtozM110gFwwp4Ufp, an absolutely positioned
 *    overlay (inset:0, opacity:0) sitting on top of the product image, revealed only on hover
 *    above 768px. This relocates that block to the end of the card and makes it always
 *    visible, so the card reads image / vendor / title / price / button like the homepage
 *    cards. The card root is a flex column, so appending puts it at the bottom.
 *
 * 2. Product Range and Brand facets open by default
 *    Their facet component is v("div",{class:"zW9tLPczR2Ar9xKLefmK"}, <button>, isOpen &&
 *    <div class="h5WfcE3fR9IVdd3YHY6N">). The panel element only exists while open, which
 *    makes "is it collapsed" an exact test rather than a guess. Collapsed named facets get one
 *    synthetic click on their own toggle button — their state, their handler, no CSS fighting.
 *
 * 3. "View All 10 Results" -> "View All Results"
 *    The dropdown prints its page size, not the total. Searchspring returns 2,326 results for
 *    "pen" over 233 pages while the label claims 10, so the number is simply wrong. Rather
 *    than assert a total this script cannot verify, the number is dropped. The real fix is for
 *    the vendor to use pagination.totalResults.
 *
 * All three are cosmetic, idempotent and fail quiet. Class names are build-generated hashes
 * and will change if the vendor rebuilds the bundle; generic fallbacks are used where
 * practical so a hash change degrades rather than breaks.
 *
 * Debug: add ?searchux=debug to any URL.
 */
(function () {
  'use strict';

  if (window.__mosSearchUx) return;
  var API = (window.__mosSearchUx = { version: 10, ctaMoved: 0, facetsOpened: 0, labelsFixed: 0, labelsLeft: 0, slidersNudged: 0, totalsSeen: 0, variantsSeen: 0, ctasAdded: 0, added: 0, jumped: null, shipLinks: 0 });

  var CFG = window.mosSearchUxConfig || {};
  var MOVE_CTA = CFG.moveCta !== false;
  var OPEN_FACETS = CFG.openFacets !== false;
  var FIX_LABEL = CFG.fixLabel !== false;
  var PIN_GRID = CFG.pinGrid !== false;
  var ADD_CTA = CFG.addDdCta !== false;
  var JUMP = CFG.singleResultJump !== false;
  var SHIP_LINK = CFG.shipLink !== false;
  var SHIP_PHRASE = (CFG.shipPhrase || 'conditions apply').toLowerCase();
  var SHIP_URL = CFG.shipUrl || '/pages/shipping';
  var CART_LABEL = CFG.cartLabel || 'Add to Cart';
  var QUOTE_LABEL = CFG.quoteLabel || 'Add to Quote';
  var VIEW_LABEL = CFG.viewLabel || 'View Product';
  var FACET_NAMES = (CFG.facetNames || 'Product Range,Brand')
    .split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

  var CARD = '.xAV3RRaqDUztoLk9wNZv';
  var OVERLAY = '.cgivtozM110gFwwp4Ufp';
  var FACET = '.zW9tLPczR2Ar9xKLefmK';
  var FACET_BTN = '.yPnDTFlbSMHOsI_alxBs';
  var FACET_PANEL = '.h5WfcE3fR9IVdd3YHY6N';
  var FACET_LABEL = '.gNVdK4aq6avFepFvUUNB';
  var DONE = 'data-mos-ux';
  var DDCTA = 'data-mos-ddcta';      // which button this card currently has
  var WROTE = 'data-mos-ux-label';   // exact text we last wrote, so we only write on change
  var DEBUG = location.search.indexOf('searchux=debug') !== -1;

  /* ---------- 1. move the card CTA below the price ---------- */

  function moveCtas() {
    var cards = document.querySelectorAll(CARD + ', a[href*="/products/"]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var overlay = card.querySelector(OVERLAY);
      if (!overlay || overlay.getAttribute(DONE) === 'cta') continue;
      // Already the last child? Nothing to do.
      if (card.lastElementChild !== overlay) card.appendChild(overlay);
      overlay.setAttribute(DONE, 'cta');
      card.setAttribute('data-mos-cta-below', '1');
      API.ctaMoved++;
    }
  }

  /* ---------- 2. open named facets ---------- */

  function facetLabel(facet) {
    var span = facet.querySelector(FACET_LABEL);
    var btn = facet.querySelector(FACET_BTN) || facet.querySelector('button');
    var text = (span && span.textContent) || (btn && btn.textContent) || '';
    return text.trim().toLowerCase();
  }

  function openFacets() {
    var facets = document.querySelectorAll(FACET);
    for (var i = 0; i < facets.length; i++) {
      var facet = facets[i];
      if (facet.getAttribute(DONE) === 'facet') continue;      // only ever try once
      var label = facetLabel(facet);
      if (!label) continue;
      var wanted = false;
      for (var j = 0; j < FACET_NAMES.length; j++) {
        if (label.indexOf(FACET_NAMES[j]) !== -1) { wanted = true; break; }
      }
      if (!wanted) continue;

      facet.setAttribute(DONE, 'facet');
      if (facet.querySelector(FACET_PANEL)) continue;          // already open: never re-click
      var btn = facet.querySelector(FACET_BTN) || facet.querySelector('button');
      if (!btn) continue;
      btn.click();
      API.facetsOpened++;
    }
  }

  /* ---------- 3. put the real result count in the View All label ---------- */

  // The theme asks Searchspring for the total and then prints its page size instead.
  // The correct number is already in the response it received, so rather than make a second
  // request we watch its fetch go past and keep pagination.totalResults, keyed by query.
  // Read-only: the original promise is handed back untouched and every step swallows errors,
  // so a change at their end degrades to dropping the number rather than breaking search.
  var totals = {};
  var lastTotal = null;

  function queryFromUrl(url) {
    var m = /[?&]q=([^&]*)/.exec(url || '');
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().toLowerCase(); }
    catch (e) { return m[1].toLowerCase(); }
  }

  // handle -> variant, harvested from the same response. The card markup the theme builds
  // drops variant_id on the floor, which is the only reason its dropdown cannot have a
  // working button. Nothing here is a second request.
  var variants = {};

  function noteVariants(data) {
    var rs = data && data.results;
    if (!rs || !rs.length) return;
    for (var i = 0; i < rs.length; i++) {
      var r = rs[i] || {};
      var h = (r.handle || '').toString().toLowerCase();
      if (!h && r.url) h = handleOf(r.url);
      var vid = r.variant_id;
      if (!h || !vid) continue;
      variants[h] = {
        id: String(vid),
        available: !(r.ss_available === 0 || r.ss_available === '0' || r.ss_available === false)
      };
      API.variantsSeen++;
    }
  }

  /* ---------- 6. one result, or an exact code match, goes straight to the product ---------- */

  // Typing a part number and landing on a results page holding one card is a wasted click.
  // The same response we already read gives us both the total and every result's SKU, so we
  // can send the customer to the product instead.
  //
  // The exact-match test is deliberately narrow: the query must be whitespace-free, at least
  // four characters, and equal to a SKU once punctuation is stripped. "PP720207" qualifies.
  // "guillotine 56" does not, so a broad search is never hijacked by a coincidental code.

  var bySku = {};        // normalised sku -> product url
  var singles = {};      // query -> the only product url for it
  var jumped = false;

  function normCode(v) {
    return String(v == null ? '' : v).toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function looksLikeCode(q) {
    if (!q || /\s/.test(q)) return false;
    return normCode(q).length >= 4;
  }

  function noteCodes(url, data) {
    var rs = (data && data.results) || [];
    for (var i = 0; i < rs.length; i++) {
      var r = rs[i] || {};
      var u = r.url || (r.handle ? '/products/' + r.handle : '');
      if (!u) continue;
      var codes = [r.sku, r.ss_sku];
      if (Array.isArray(r.variant_sku)) codes = codes.concat(r.variant_sku);
      for (var j = 0; j < codes.length; j++) {
        var k = normCode(codes[j]);
        if (k.length >= 4 && !bySku[k]) bySku[k] = u;
      }
    }
    var q = queryFromUrl(url);
    var total = data && data.pagination && data.pagination.totalResults;
    if (q && total === 1 && rs.length === 1) {
      var only = rs[0].url || (rs[0].handle ? '/products/' + rs[0].handle : '');
      if (only) singles[q] = only;
    }
  }

  // Where should this query go, if anywhere? null means "leave it alone".
  function jumpTarget(q) {
    if (!JUMP || !q) return null;
    var key = q.trim().toLowerCase();
    if (singles[key]) return singles[key];
    if (looksLikeCode(key)) {
      var hit = bySku[normCode(key)];
      if (hit) return hit;
    }
    return null;
  }

  // On the results page itself: replace rather than assign, so Back returns to wherever the
  // customer actually came from instead of bouncing them forward again.
  function maybeJumpFromResultsPage() {
    if (jumped || !JUMP) return;
    if (location.pathname.indexOf('/search') !== 0) return;
    var m = /[?&]q=([^&]*)/.exec(location.search);
    if (!m) return;
    var q;
    try { q = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { q = m[1]; }
    var target = jumpTarget(q);
    if (!target) return;
    jumped = true;
    API.jumped = target;
    location.replace(target);
  }

  // On submit from the search box: go straight there and skip the results page entirely.
  // Capture phase, so this runs before the theme's own keyup handler navigates to /search.
  function wireSubmitJump() {
    if (!JUMP || window.__mosSearchUxJump) return;
    window.__mosSearchUxJump = true;
    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.keyCode !== 13) return;
      var el = ev.target;
      if (!el || !el.matches || !el.matches('input[type="search"], input[name="q"], .search__input')) return;
      var target = jumpTarget(el.value || '');
      if (!target) return;                       // unknown: let the theme do its thing
      ev.preventDefault();
      ev.stopPropagation();
      API.jumped = target;
      location.assign(target);
    }, true);
  }

  function noteTotal(url, data) {
    noteVariants(data);
    noteCodes(url, data);
    var t = data && data.pagination && data.pagination.totalResults;
    if (typeof t === 'number' && t >= 0) {
      totals[queryFromUrl(url)] = t;
      lastTotal = t;
      API.totalsSeen++;
    }
    maybeJumpFromResultsPage();
    schedule();                                  // relabel / add buttons now we know more
  }

  function wrapFetch() {
    if (!window.fetch || window.__mosSearchUxFetch) return;
    window.__mosSearchUxFetch = true;
    var orig = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var out = orig.apply(this, arguments);
      if (url.indexOf('searchspring.io/api/search/') !== -1) {
        try {
          out.then(function (r) {
            try {
              r.clone().json()
                .then(function (d) { try { noteTotal(url, d); } catch (e) {} })
                .catch(function () {});
            } catch (e) {}
          }).catch(function () {});
        } catch (e) {}
      }
      return out;                                // untouched
    };
  }

  function currentQuery() {
    var el = document.querySelector(
      'predictive-search input[type="search"], .search__input, input[name="q"], input[type="search"]');
    return el && el.value ? el.value.trim().toLowerCase() : '';
  }

  function knownTotal() {
    var q = currentQuery();
    if (q && typeof totals[q] === 'number') return totals[q];
    return typeof lastTotal === 'number' ? lastTotal : null;
  }

  function formatCount(n) {
    try { return n.toLocaleString('en-AU'); } catch (e) { return String(n); }
  }

  var LABEL_RE = /^(\s*view\s+(?:all\s+)?)([\d,\.]*)(\s*results?\s*)$/i;

  // How many product cards the dropdown is actually showing. Verified selectors from
  // the theme's own buildSsDropdownResultsMarkup() in assets/predictive-search.js.
  function shownCardCount() {
    var n = document.querySelectorAll(
      '.predictive-search__results-list_products > li, ' +
      '.predictive-search__list-item.collection-product-card'
    ).length;
    return n;
  }

  // Targeted, not every a/button/span/div/p on the page. Scanning all of them and reading
  // textContent measured 4ms a pass on a Mega collection page and scaled with page size;
  // this scales with the handful of elements that can actually carry the label.
  var LABEL_SEL = [
    '.predictive-search__view-all',
    '.bottom-search-link a',
    '[class*="seeAll"]',
    '[class*="viewAll"]',
    '[class*="ViewAll"]',
    'a[href*="/search?"]',
    'button[class*="view"]'
  ].join(', ');

  function fixLabels(root) {
    var nodes = (root || document).querySelectorAll(LABEL_SEL);
    var shown = shownCardCount();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;                        // text-only nodes
      var t = el.textContent;
      var m = t ? LABEL_RE.exec(t) : null;
      if (!m) continue;
      // Only drop the number when it cannot be a real total: it is no larger than the
      // handful of cards on screen, i.e. it is the page size being printed as a total.
      // The theme reads pagination.totalResults, which IS correct (2,326 for "pen"), so
      // a number above the card count is left alone rather than thrown away.
      var num = parseInt(String(m[2]).replace(/[,\.]/g, ''), 10);

      // Two kinds of label. Inside the header dropdown the count has always been the page
      // size rather than the total — Searchspring returns 2,322 for "pens" and the button
      // says 10 — so drop it there without further argument. Anywhere else, only drop a
      // number that cannot be a total because it is no larger than what is on screen.
      var inDropdown = !!(el.closest && el.closest(
        '.predictive-search__view-all, .bottom-search-link, .predictive-search__result-group-header'
      )) || (el.className || '').toString().indexOf('predictive-search__view-all') !== -1;

      if (!inDropdown && !(shown > 0 && num > 0 && num <= shown)) {
        el.setAttribute(DONE, 'label');                        // judged correct; never revisit
        API.labelsLeft++;
        continue;
      }

      var real = inDropdown ? knownTotal() : null;
      var want;
      if (typeof real === 'number' && real > 0) {
        want = real === 1 ? 'View 1 Result' : 'View All ' + formatCount(real) + ' Results';
      } else {
        // No total observed yet — say nothing false rather than repeat the page size.
        want = t.replace(LABEL_RE, '$1$3').replace(/\s+/g, ' ').trim();
      }

      if (el.getAttribute(WROTE) === want) continue;           // already says this
      el.textContent = want;
      el.setAttribute(WROTE, want);
      el.setAttribute(DONE, 'label');
      API.labelsFixed++;
    }
  }

  /* ---------- 4. make the dropdown slider re-measure ---------- */

  // initProductsSlider() builds the Swiper with slidesPerView:'auto', so slide widths are
  // read from CSS once at init. If anything is still settling at that moment the widths are
  // wrong and nothing re-reads them, because no resize event follows. update() is Swiper's
  // own re-measure, it is cheap and idempotent, so it is safe to call a few times.
  function nudgeSlider() {
    var sliders = document.querySelectorAll('.predictive-search-products-slider.swiper');
    for (var i = 0; i < sliders.length; i++) {
      var sw = sliders[i].swiper;
      if (!sw || sw.destroyed) continue;
      if (sliders[i].getAttribute(DONE) === 'nudged') continue;
      sliders[i].setAttribute(DONE, 'nudged');
      try { sw.update(); API.slidersNudged++; } catch (e) {}
    }
  }

  /* ---------- 5. a working button on the header dropdown cards ---------- */

  // buildSsDropdownCard() in assets/predictive-search.js renders image, brand, title and
  // price and no button at all — not hidden by CSS, simply never built. That file is a 41KB
  // vendor bundle, so the button is added here instead.
  //
  // Safety: a quote-only product must never get a cart button. The verdict comes from
  // mos-quote-only.js, and until that list has resolved no button is rendered at all. If the
  // list resolved by failing, every card gets "View Product" rather than a cart button —
  // failing towards the product page, never towards the cart.

  function handleOf(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    if (!m) return '';
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch (e) { return m[1].toLowerCase(); }
  }

  function dropdownCards() {
    return document.querySelectorAll(
      '.predictive-search__results-list_products > li, ' +
      '.predictive-search__list-item.collection-product-card'
    );
  }

  function cartAdd(id) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', String(id));
    fd.append('quantity', '1');
    // Ask for the drawer's sections in the same request, exactly as the theme's own
    // product-form.js does, so the drawer can re-render without a second round trip.
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        fd.append('sections', drawer.getSectionsToRender().map(function (sec) { return sec.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      } catch (e) {}
    }
    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status) throw new Error(res.description || res.message || 'cart error');
      try {
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate,
            { source: 'mos-search-ux', productVariantId: String(id) });
        }
      } catch (e) {}
      return res;
    });
  }

  function onAddClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();                        // the card has a full-size overlay link
    var btn = ev.currentTarget;
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var card = (btn.closest && btn.closest('li')) || btn.parentElement;
    var link = card && card.querySelector('a[href*="/products/"]');
    var h = link ? handleOf(link.getAttribute('href')) : '';
    var qo = window.__mosQuoteOnly;

    // Re-check at the moment of the click, not just at render time.
    if (h && qo && qo.ready && (qo.failed || qo.isQuoteOnly(h))) {
      window.location.href = '/products/' + h;
      return;
    }

    var id = btn.getAttribute('data-mos-variant');
    if (!id) { if (h) window.location.href = '/products/' + h; return; }

    var was = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Adding\u2026';
    cartAdd(id).then(function () {
      API.added++;
      btn.textContent = 'Added';
      setTimeout(function () {
        btn.textContent = was;
        btn.removeAttribute('aria-disabled');
      }, 1500);
    }).catch(function (err) {
      if (DEBUG) console.warn('[mos-search-ux] cart add failed', err);
      btn.textContent = was;
      btn.removeAttribute('aria-disabled');
      if (h) window.location.href = '/products/' + h;   // never leave a dead button
    });
  }

  // What button does this handle deserve, given what we currently know?
  // "view" is the answer whenever we cannot be certain, and it can be upgraded later:
  // the Searchspring response often lands after the cards are already on screen, so the
  // decision is recorded as a signature and revisited rather than being made once.
  function ctaPlan(h, qo) {
    if (qo.failed) return { kind: 'view' };                    // no verdict: never the cart
    if (qo.isQuoteOnly(h)) return { kind: 'quote' };
    var v = variants[h];
    if (v && v.id && v.available) return { kind: 'cart', id: v.id };
    return { kind: 'view' };
  }

  function buildCta(h, plan) {
    var el;
    if (plan.kind === 'cart') {
      el = document.createElement('button');
      el.type = 'button';
      el.textContent = CART_LABEL;
      el.setAttribute('data-mos-variant', plan.id);
      el.addEventListener('click', onAddClick);
    } else {
      el = document.createElement('a');
      el.setAttribute('href', '/products/' + h);
      el.textContent = plan.kind === 'quote' ? QUOTE_LABEL : VIEW_LABEL;
    }
    el.className = 'button button--primary mos-dd-cta';
    return el;
  }

  function addDropdownCtas() {
    var qo = window.__mosQuoteOnly;
    if (!qo || !qo.ready) return;                // no verdict yet: render nothing at all
    var cards = dropdownCards();
    for (var i = 0; i < cards.length; i++) {
      var li = cards[i];
      var link = li.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var h = handleOf(link.getAttribute('href'));
      if (!h) continue;
      var root = li.querySelector('.product-card') || li.firstElementChild;
      if (!root) continue;

      var plan = ctaPlan(h, qo);
      var sig = plan.kind + ':' + (plan.id || '') + ':' + h;
      if (li.getAttribute(DDCTA) === sig) continue;             // already correct

      var existing = li.querySelector('.mos-dd-cta');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

      root.appendChild(buildCta(h, plan));
      li.setAttribute(DDCTA, sig);
      API.ctasAdded++;
    }
  }

  /* ---------- 7. link "conditions apply" in the cart shipping bar ---------- */

  // The message is a theme setting (settings.message_shipping) which assets/cart.js writes
  // with innerText, so markup put in the setting is escaped rather than rendered. It is also
  // rewritten on every cart update, which is why this re-applies rather than running once.
  // Built from text nodes and a single anchor — no innerHTML, nothing from the setting is
  // ever parsed as markup.
  var SHIP_SEL = '.cart-shipping__message_default, .cart-shipping__message_success, .cart-shipping__message';

  function linkShipping() {
    var nodes = document.querySelectorAll(SHIP_SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector('a[data-mos-ship]')) continue;      // already linked
      var text = el.textContent || '';
      var at = text.toLowerCase().indexOf(SHIP_PHRASE);
      if (at === -1) continue;

      var before = text.slice(0, at);
      var phrase = text.slice(at, at + SHIP_PHRASE.length);     // keep the author's casing
      var after = text.slice(at + SHIP_PHRASE.length);

      var a = document.createElement('a');
      a.setAttribute('href', SHIP_URL);
      a.setAttribute('data-mos-ship', '1');
      a.textContent = phrase;

      el.textContent = '';
      if (before) el.appendChild(document.createTextNode(before));
      el.appendChild(a);
      if (after) el.appendChild(document.createTextNode(after));
      API.shipLinks++;
    }
  }

  /* ---------- run ---------- */

  function apply() {
    try {
      if (MOVE_CTA) moveCtas();
      if (OPEN_FACETS) openFacets();
      if (FIX_LABEL) fixLabels(document);
      if (PIN_GRID) nudgeSlider();
      if (ADD_CTA) addDropdownCtas();
      if (SHIP_LINK) linkShipping();
    } catch (e) {
      if (DEBUG) console.warn('[mos-search-ux]', e);
    }
  }

  var timer = null;
  var QUIET = 120;   // collapse a burst of Preact re-renders into a single pass

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      if (window.requestAnimationFrame) window.requestAnimationFrame(apply);
      else apply();
    }, QUIET);
  }

  function start() {
    wrapFetch();
    wireSubmitJump();
    apply();
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          if (!added) continue;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n && n.nodeType === 1) { schedule(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    [300, 900, 2000, 3500].forEach(function (ms) { setTimeout(schedule, ms); });
    document.addEventListener('input', schedule, true);        // header search typing
    if (DEBUG) readout();
  }

  function readout() {
    setTimeout(function () {
      var el = document.createElement('pre');
      el.style.cssText =
        'position:fixed;z-index:2147483647;bottom:8px;left:8px;margin:0;padding:12px 14px;' +
        'background:#0A3370;color:#FFFFFF;font:12px/1.5 ui-monospace,Menlo,monospace;' +
        'border-radius:10px;white-space:pre;user-select:all;max-width:96vw;' +
        'box-shadow:0 6px 24px rgba(0,0,0,.35)';
      el.textContent = [
        'SEARCH UX  v' + API.version,
        'card CTAs moved below price   ' + API.ctaMoved,
        'facets opened                 ' + API.facetsOpened + '   (' + FACET_NAMES.join(', ') + ')',
        'View All labels corrected     ' + API.labelsFixed,
        'real totals observed          ' + API.totalsSeen + '   (latest: ' + (lastTotal === null ? 'none yet' : formatCount(lastTotal)) + ')',
        'View All labels left alone    ' + API.labelsLeft + '   (number looked like a real total)',
        'dropdown cards on screen      ' + shownCardCount(),
        'dropdown sliders re-measured  ' + API.slidersNudged,
        'dropdown buttons added        ' + API.ctasAdded + '   (variants known: ' + API.variantsSeen + ')',
        'added to cart this page       ' + API.added,
        'single-result jump            ' + (API.jumped || 'no') ,
        'codes indexed                 ' + Object.keys(bySku).length,
        'shipping links added          ' + API.shipLinks,
        'cards seen                    ' + document.querySelectorAll(CARD).length,
        'facets seen                   ' + document.querySelectorAll(FACET).length
      ].join('\n');
      document.body.appendChild(el);
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
